import { api } from "../api/Middleware";
import { ACCOUNT_URL } from "../api/Urls";

const AccountActivationService = {
  /**
   * Ativar conta usando token, email e senha
   * POST /api/account/activate/
   */
  activateAccount: async (token, email, password = null) => {
    try {
      const response = await api.post(ACCOUNT_URL + "activate/", {
        token,
        email,
        password
      });
      
      // Se ativação foi bem-sucedida, redirecionar para login
      if (response.data.success) {
        // Salvar mensagem de sucesso para exibir no login
        sessionStorage.setItem("activation_success_message", response.data.message);
        
        // Verificar se há URL customizada para login
        const loginUrl = response.data.next_steps?.login_url || "/login";
        
        // Se é URL externa (com https://), usar window.location.href
        if (loginUrl.startsWith("http")) {
          window.location.href = loginUrl;
        } else {
          // Se é rota interna, usar rota relativa
          window.location.href = loginUrl;
        }
      }
      
      return response.data;
    } catch (error) {
      console.error("Error activating account:", error);
      
      // Tratamento específico de erros
      if (error.response) {
        const { status, data } = error.response;
        
        switch (status) {
          case 400:
            throw new Error(data.error || "Dados inválidos para ativação");
          case 404:
            throw new Error("Token inválido ou conta não encontrada");
          case 500:
            throw new Error("Erro interno do servidor. Tente novamente mais tarde");
          default:
            throw new Error(data.error || "Erro desconhecido ao ativar conta");
        }
      } else if (error.request) {
        throw new Error("Erro de conexão. Verifique sua internet e tente novamente");
      } else {
        throw new Error("Erro inesperado. Tente novamente");
      }
    }
  }
};

export default AccountActivationService;